module.exports = __webpack_public_path__ + "static/gooseberry-pointer-46e6e583c5731595d33c116f8e1f032f.png";